import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { User } from '../auth/user.model';
import { AuthService } from '../auth/auth.service';
import { Subscription } from 'rxjs/index';
import { UIService } from '../shared/ui.service';
import { Order } from '../order/order.model';
import { OrderService } from '../order/order.service';
import { InvoiceService } from './invoice.service';
import { MatDialog } from '@angular/material';
import { MustFillProfileComponent } from '../reservation/dialog/must-fill-profile/must-fill-profile.component';
import { NeedASwitchComponent } from '../reservation/dialog/need-a-switch/need-a-switch.component';
import { StorageService } from '../storage/storage.service';
import { Permission } from '../access/access.service';

@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.css']
})
export class InvoiceComponent implements OnInit, AfterViewInit, OnDestroy {
  user: User;
  base_invoices: Order[];
  other_invoices: Order[];
  supplier_invoices: Order[];
  extra_invoices: Order[];
  estimate_invoices: Order[];
  day_extra_invoices: Order[];
  isLoading = false;
  currentLanguage = 'en';
  private loadingSubscription: Subscription;
  private selectedProjectSubscription: Subscription;
  currentProject: number;
  hasAccessToData: boolean;


  constructor(
    private invoiceService: InvoiceService,
    private authentication: AuthService,
    public dialog: MatDialog,
    private uiService: UIService,
    private _ref: ChangeDetectorRef,
    private localStorage: StorageService) { }

  ngOnInit() {
    this.currentLanguage = this.localStorage.getPreferredLanguage();
    this.loadingSubscription = this.uiService.loadingStateChanged.subscribe(isLoading => {
      this.isLoading = isLoading;
      this._ref.markForCheck();
    });
    this.user = this.authentication.getUser();
    this.getInvoices();

    this.hasAccessToData = this.validateAccessToData();

    this.selectedProjectSubscription = this.uiService.selectedProjectChanged.subscribe(projectId => {
      this.currentProject = projectId
      this.getInvoices();
      this.hasAccessToData = this.validateAccessToData();
    });
  }

  validateAccessToData() {
    return this.authentication.hasAccessToProject(this.currentProject, Permission.ADMIN);
  }

  getInvoices() {
    this.invoiceService.getInvoices(this.user.token).subscribe(response => {
        this.base_invoices = response['base_invoices'];
        this.other_invoices = response['other_invoices'];
        this.supplier_invoices = response['supplier_invoices'];
        this.extra_invoices = response['extra_invoices'];
        this.estimate_invoices = response['estimate_invoices'];
        this.day_extra_invoices = response['day_extra_invoices'];
        this.uiService.loadingStateChanged.next(false);
    },(error: Error) => {
        if(error ){
          this.base_invoices = [];
          this.other_invoices = [];
          this.supplier_invoices = [];
          this.extra_invoices = [];
          this.estimate_invoices = [];
          this.day_extra_invoices = [];
          this.uiService.loadingStateChanged.next(false);
      }});
  }

  ngAfterViewInit() {

  }

  onReserveContainerClick(event: Event) {
    if (this.user.profile_is_set) {
      this.openReservationDialog();
    } else {
      this.openDialog();
    }
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(MustFillProfileComponent);
  }

  openReservationDialog(): void {
    const dialogRef = this.dialog.open(NeedASwitchComponent);
  }

  ngOnDestroy() {
    this.loadingSubscription.unsubscribe();
    this.selectedProjectSubscription.unsubscribe();
  }

  handleClick(event: Event) {
    console.log('Click!', event);
  }



}
